import { default as Modal } from 'antd/es/modal';

import type { IntegrationBusinessUnit } from 'api';

import { PrimaryButton } from '@atoms/buttons/PrimaryButton';
import { SecondaryButton } from '@atoms/buttons/SecondaryButton';

import {
  DELETE_BUSINESS_UNIT_CANCEL_TEST_ID,
  DELETE_BUSINESS_UNIT_CONFIRM_LABEL,
  DELETE_BUSINESS_UNIT_CONFIRM_TEST_ID,
  DELETE_BUSINESS_UNIT_MODAL_TEST_ID,
  DELETE_BUSINESS_UNIT_MODAL_WIDTH,
  DELETE_BUSINESS_UNIT_TITLE,
  deleteBusinessUnitBody
} from './constants';
import { useDeleteBusinessUnit } from './useDeleteBusinessUnit';

type DeleteBusinessUnitModalProps = {
  businessUnit: IntegrationBusinessUnit;
  open: boolean;
  onCancel: () => void;
  onConfirmed: () => void;
};

export const DeleteBusinessUnitModal = ({
  businessUnit,
  open,
  onCancel,
  onConfirmed
}: DeleteBusinessUnitModalProps) => {
  const { deleteBusinessUnit, isPending } = useDeleteBusinessUnit();

  const cancel = () => {
    if (isPending) return;
    onCancel();
  };

  return (
    <Modal
      open={open}
      onCancel={cancel}
      width={DELETE_BUSINESS_UNIT_MODAL_WIDTH}
      destroyOnHidden
      closable={!isPending}
      maskClosable={!isPending}
      keyboard={!isPending}
      title={
        <div className="text-lg font-medium text-content-primary">
          {DELETE_BUSINESS_UNIT_TITLE}
        </div>
      }
      footer={
        <div className="flex justify-end gap-2">
          <SecondaryButton
            data-testid={DELETE_BUSINESS_UNIT_CANCEL_TEST_ID}
            onClick={cancel}
            disabled={isPending}
          >
            Cancel
          </SecondaryButton>
          <PrimaryButton
            data-testid={DELETE_BUSINESS_UNIT_CONFIRM_TEST_ID}
            danger
            type="default"
            loading={isPending}
            disabled={isPending}
            onClick={() => deleteBusinessUnit(businessUnit.uuid, onConfirmed)}
          >
            {DELETE_BUSINESS_UNIT_CONFIRM_LABEL}
          </PrimaryButton>
        </div>
      }
    >
      <p
        data-testid={DELETE_BUSINESS_UNIT_MODAL_TEST_ID}
        className="text-base text-content-primary"
      >
        {deleteBusinessUnitBody(businessUnit.name)}
      </p>
    </Modal>
  );
};
